// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3xqso","sendOtp":"AuthorizeToLogin_sendOtp__1e-Go"};